export default __webpack_public_path__ + "static/media/laudiologo.f099c177.png";